module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('text', {
    ref: "dof-slider-scale",
    class: [
      'dof-slider-scale',
      !_vm.isFirst && !_vm.isLast && 'dof-slider-scale--mid',
      _vm.isFirst && "dof-slider-scale--first",
      _vm.isLast && "dof-slider-scale--last",
      _vm._isColmo && "colmoFont"
    ],
    style: _vm.style
  }, [_vm._t("default")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-5b637e77!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-slider-scale/index.vue
// module id = 616
// module chunks = 0 1